import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 21a9 9 0 0 0 9 -9a9 9 0 0 0 -9 -9a9 9 0 0 0 -9 9a9 9 0 0 0 9 9z","key":"svg-0"}],["path",{"d":"M8.5 8.5l7 7","key":"svg-1"}],["path",{"d":"M8.5 15.5l7 -7","key":"svg-2"}]]

const IconPlaystationX = createReactComponent('outline', 'playstation-x', 'PlaystationX', __iconNode);

export default IconPlaystationX;